export const ENGAGEMENT_EVENTS = Object.freeze({
  VISIT: "visit",
  REPORT_STARTED: "report_started",
  REPORT_DOMAIN_SELECTED: "report_domain_selected",
  REPORT_STEP_VIEWED: "report_step_viewed",
  REPORT_VALIDATION_BLOCKED: "report_validation_blocked",
  REPORT_SUBMITTED: "report_submitted",
  REPORT_QUEUED_OFFLINE: "report_queued_offline",
  REPORT_SUBMIT_FAILED: "report_submit_failed",
  REPORT_COMPLETED: "report_completed",
  REPORT_ABANDONED: "report_abandoned",
});

export const ENGAGEMENT_PROPERTIES = Object.freeze({
  DOMAIN: "domain",
  STEP: "step",
  STATUS: "status",
  ONLINE: "online",
  VALIDATION_REASON: "validation_reason",
  APP_VERSION: "app_version",
});

export const ENGAGEMENT_DOMAINS = Object.freeze([
  "people",
  "animals",
  "environment",
  "no_concern",
]);

export function reportDomainForScreen(screenName) {
  const screen = String(screenName || "");
  if (screen.startsWith("people-")) return "people";
  if (screen.startsWith("animals-")) return "animals";
  if (screen.startsWith("environment-")) return "environment";
  return "";
}
